import React, { useEffect, useState } from "react";
import {
  Button, DatePicker, Form, Typography,
  useSnackbar,
} from "@kitbird/core";
import styled from "styled-components";
import Modal from "../../../../../components/Modal";
import useCloseReceipt from "../../useCloseReceipt";

interface ModalVerifyTransferProps {
  useCustomHook: ReturnType<typeof useCloseReceipt>;
}

const FormWrapper = styled.div`
  display: grid;
  gap: 24px;
`;

const ModalVerifyTransfer = ({ useCustomHook }: ModalVerifyTransferProps) => {
  const {
    selectedRows,
    isVerifyTransferModal,
    setVerifyTransferModal,
    dataWhiteReceipt,
    uploadedMedia,
    setUploadedMedia,
    transferDate,
    setTransferDate,
    processFiles,
    handleSendTransferProof,
    initErrors,
    errorMessages,
    setErrorMessages,
  } = useCustomHook;
  const snackbar = useSnackbar();

  useEffect(() => {
    if (!isVerifyTransferModal) {
      setErrorMessages(initErrors);
    }
  }, [isVerifyTransferModal]);

  useEffect(() => {
    if (uploadedMedia && !errorMessages.uploadedMedia) setErrorMessages((curr) => ({ ...curr, uploadedMedia: "" }));
  }, [uploadedMedia]);

  useEffect(() => {
    if (transferDate) setErrorMessages((curr) => ({ ...curr, transferDate: "" }));
  }, [transferDate]);

  useEffect(() => {
    if (errorMessages.uploadedMedia) setUploadedMedia(undefined);
  }, [errorMessages.uploadedMedia]);

  const onClickVerify = () => {
    if (!uploadedMedia) setErrorMessages((curr) => ({ ...curr, uploadedMedia: "Harap upload bukti transfer" }));
    if (!transferDate) setErrorMessages((curr) => ({ ...curr, transferDate: "Harap pilih tanggal transfer" }));

    if (uploadedMedia && transferDate) handleSendTransferProof(selectedRows[0].trx_id_bm);
    else snackbar.show("Gagal mengirim bukti transfer, harap lengkapi bukti dan/atau tanggal transfer", "error");
  };

  const onChangeFile = (e?: React.ChangeEvent<HTMLInputElement>) => {
    processFiles(e?.target.files || null);
    setErrorMessages((curr) => ({ ...curr, uploadedMedia: "" }));
  };

  const onChangeDate = (val: Date | Date[] | null) => {
    if (!Array.isArray(val)) {
      setTransferDate(val || undefined);
      setErrorMessages((curr) => ({ ...curr, transferDate: "" }));
    }
  };

  const renderUploadForm = <Form
    type="file"
    label="Bukti transfer"
    name="transfer-proof"
    onChange={onChangeFile}
    onClear={onChangeFile}
    value={uploadedMedia?.FileName || ""}
    accept=".pdf, .jpeg, .jpg, .png"
    error={errorMessages.uploadedMedia
      ? { message: errorMessages.uploadedMedia }
      : undefined
    }
  />;

  return (
    <Modal
      isOpen={isVerifyTransferModal}
      setOpen={setVerifyTransferModal}
      title="Pengajuan verifikasi transfer"
      body={<FormWrapper>
        {uploadedMedia && renderUploadForm}
        {!uploadedMedia && renderUploadForm}
        <DatePicker
          label="Tanggal transfer"
          onChange={onChangeDate}
          variant="default"
          onSubmit={onChangeDate}
          onReset={() => setTransferDate(undefined)}
          maxDate={new Date()}
          error={errorMessages.transferDate ? { message: errorMessages.transferDate } : undefined}
        />
      </FormWrapper>}
      footer={dataWhiteReceipt
        && <>
          <Button
            variant="text"
            onClick={() => setVerifyTransferModal(false)}
          >Batal</Button>
          <Button
            onClick={onClickVerify}
          >Ajukan</Button>
        </>
      }
    />
  );
};

export default ModalVerifyTransfer;
